import ModalFormSubmitButton from 'components/modal/form/ModalFormSubmitButton';
import styled from 'styled-components';

export const StateStyled = styled.div`
  align-items: center;
  display: flex;
  gap: 5px;
  padding-right: 15px;

  > span {
    display: flex;
  }

  svg {
    margin-top: 2px;
  }
`;

export const ModalFormSubmitButtonStyled = styled(ModalFormSubmitButton)`
  margin-left: 5px;
`;

export const StateMessageStyled = styled.div`
  display: flex;
  flex-direction: column;
`;
